import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("modal", ["clearModal"]),
  },
};
